module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAACgCAMAAAC11vUgAAAAV1BMVEX/QlYAAAD/LFb/Qlb/Qlf/Qlb/Qlb/Qlb/Qlb/Qlb/Qlb/QVb/Qlf/Qlf/QVj/QVj/RlX/Q1n/O07/Qlb/////+Pn/doT/7e//X3D/go//Znb/V2n/VWdCrp3oAAAAE3RSTlN/AATTj/jx6NvEsphkVUM3IRcNjGr12wAAAKxJREFUWMPt2M0KwjAQBOCYxN9Wa12tv+//nB5EljKHOSyUFmbOHyxJNpdJyQyzKfWUV7/8BWZ3BAE5XJiw0jNh+8yEVSrWZyasoWKbmbCOipaKJCEhISEhIbFY8XoSMdyuw1gguH/GAsEDpgAAAQAEAhQIUCBA8XZARGCKk8hpnQRu3Ql/fb5BdAvn8RskJCQkJCQkphYtFV28/WriLVwNt4GlD7WS3mzydvQLa41tpD9RYNAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide/slide_10.png
// module id = jcsV
// module chunks = 23